import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';

import Loading from 'shared/ui/Loading';
import UnderConstruction from 'shared/ui/UnderConstruction';
import DevRootLayout from 'features/dev/pages/DevRoot';
import Sections from 'features/dev/pages/sections/Sections';
import TestRootLayout from 'features/dev/pages/test/TestRoot';
import { testPages } from 'features/dev/testPages';

export const devRoutes = (
  <Route path='dev' element={<Suspense fallback={<Loading />}><DevRootLayout /></Suspense>}>
    <Route path='sections' element={<Sections />} />
    <Route path='test' element={<TestRootLayout />}>
      <Route index element={<UnderConstruction />} />
      {testPages.map(({ number, Component }) => (
        <Route key={number} path={`${number}`} element={<Component />} />
      ))}
    </Route>
  </Route>
);

export const devTitles = [
  { path: '/dev/sections', title: 'Разделы' },
  { prefix: '/dev/test', title: 'Тестовый раздел' },
  { path: '/dev', title: 'Разработчикам' },
];
